// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `form#step-form-horizontal > div:last-child {
  /* text-align: right; */
  /* padding-top: 2rem; */
}

form#step-form-horizontal .form-group .text-label {
  text-align: left;
  display: block;
  /* padding-top: 2rem; */
}
[data-primary="color_2"] .wizard > .steps li.current a {
  background-color: #EB8153;
}
[data-primary="color_2"] .wizard .skip-email a {
  color: #363062;
}
[data-primary="color_2"] .wizard > .actions li:not(.disabled) a {
  background-color: #EB8153;
}

.step-form-horizontal .wizard {
  padding-top: 3.5rem;
}

.step-form-horizontal .wizard .steps li {
  position: relative;
}

.step-form-horizontal .wizard .steps li.done a {
  text-align: center;
  background-color: #fff;
  color: #6e6e6e;
}

[data-theme-version="dark"] .step-form-horizontal .wizard .steps li.done a {
  background-color: #181f39;
  color: #7e7e7e;
}

.step-form-horizontal .wizard .steps li.done a:hover {
  text-align: center;
  background-color: #fff;
  color: #6e6e6e;
}

.step-form-horizontal .wizard .steps li.done a .number {
  color: #fff;
  background: #EB8153;
  border-color: transparent;
}

[data-theme-version="dark"]
  .step-form-horizontal
  .wizard
  .steps
  li.done
  a
  .number {
  border-color: #EB8153;
}

.step-form-horizontal .wizard .steps li.current a,
.step-form-horizontal .wizard .steps li.disabled a {
  background-color: transparent;
  text-align: center;
  color: #fff;
}

.step-form-horizontal .wizard .steps li.current a:hover,
.step-form-horizontal .wizard .steps li.current a:active,
.step-form-horizontal .wizard .steps li.disabled a:hover,
.step-form-horizontal .wizard .steps li.disabled a:active {
  background-color: transparent;
  color: #fff;
}

.step-form-horizontal .wizard .steps li.current a .number {
  color: #363062;
  background: #fff;
  border: 2px solid #EB8153;
}

.step-form-horizontal .wizard .steps li.disabled a .number {
  color: #EB8153;
}

.step-form-horizontal .wizard .steps li a {
  position: relative;
  z-index: 1;
}

@media (max-width: 767.98px) {
  .step-form-horizontal .wizard .steps li a {
    padding-left: 0;
    padding-right: 0;
    margin: 0;
  }
}

@media (max-width: 575.98px) {
  .step-form-horizontal .wizard .steps li a {
    font-size: 0.75rem;
    padding-top: 0.9375rem;
  }
}

.step-form-horizontal .wizard .steps li a .number {
  position: absolute;
  top: -55px;
  left: 50%;
  transform: translateX(-50%);
  background-color: #fff;
  border: 3px solid #d7dae3;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 3rem;
  border-radius: 50px;
  width: 3rem;
}

[data-theme-version="dark"] .step-form-horizontal .wizard .steps li a .number {
  background: #181f39;
  border-color: #333a54;
}

@media only screen and (max-width: 575px) {
  .step-form-horizontal .wizard .steps li a .number {
    top: -45px;
  }
}

.step-form-horizontal .wizard .steps li:not(:last-child) {
  z-index: 1;
}

.step-form-horizontal .wizard .steps li:not(:last-child)::after {
  position: absolute;
  width: 100%;
  height: 0.375rem;
  content: "";
  left: 50%;
  top: -2.1rem;
  background-color: #EB8153;
  z-index: -1;
}

@media (max-width: 575.98px) {
  .step-form-horizontal .wizard .steps li:not(:last-child)::after {
    height: 0.375rem;
    top: -1.3125rem;
  }
}

.step-form-horizontal .wizard .steps li:not(:last-child).current::after {
  background-color: #f3f3f3;
}

[data-theme-version="dark"]
  .step-form-horizontal
  .wizard
  .steps
  li:not(:last-child).current::after {
  background: #181f39;
}

.step-form-horizontal .wizard .steps li:not(:last-child).current ~ li::after {
  background-color: #f3f3f3;
}

[data-theme-version="dark"]
  .step-form-horizontal
  .wizard
  .steps
  li:not(:last-child).current
  ~ li::after {
  background: #181f39;
}

.step-form-horizontal .wizard .actions {
  padding: 0;
}

@media only screen and (max-width: 575px) {
  .step-form-horizontal .wizard .actions {
    padding: 0;
  }
}

.step-form-horizontal ol {
  position: relative;
  display: flex !important;
  padding-left: 0;
  justify-content: space-between;
}

.step-form-horizontal ol li {
  position: relative;
  border: 0;
  margin-bottom: 0;
  background: transparent !important;
  z-index: 2;
  padding: 0 !important;
  width: 33.33%;
}

.step-form-horizontal ol li:after {
  content: none !important;
}

.step-form-horizontal ol li:before {
  content: "";
  height: 3px;
  width: 0;
  left: 0;
  top: 23px;
  position: absolute;
  background: #e23428;
  transition: all 0.5s;
  z-index: 1;
}

.step-form-horizontal ol li.go767851704 {
  text-align: center;
  background-color: #fff;
  color: #6e6e6e;
}

.step-form-horizontal ol li.go767851704:before {
  width: 100%;
}

[data-theme-version="dark"] .step-form-horizontal ol li.go767851704 {
  background-color: #181f39;
  color: #7e7e7e;
}

.step-form-horizontal ol li.go767851704:hover {
  text-align: center;
  background-color: #fff;
  color: #6e6e6e;
}

.step-form-horizontal ol li.go767851704 span {
  color: #fff;
  background: #e23428;
  border-color: transparent;
}

[data-theme-version="dark"] .step-form-horizontal ol li.go767851704 span {
  border-color: #EB8153;
}

.step-form-horizontal ol li.active,
.step-form-horizontal ol li.go2478912419,
.step-form-horizontal ol li.disabled {
  background-color: transparent;
  text-align: center;
  color: #fff;
  border: 0;
}

.step-form-horizontal ol li.active:hover,
.step-form-horizontal ol li.active:active,
.step-form-horizontal ol li.go2478912419:hover,
.step-form-horizontal ol li.go2478912419:active,
.step-form-horizontal ol li.disabled:hover,
.step-form-horizontal ol li.disabled:active {
  background-color: transparent;
  color: #fff;
}

.step-form-horizontal ol li.active span,
.step-form-horizontal ol li.go2478912419 span {
  color: #e23428;
  background: #fff;
  border: 2px solid #e23428;
}

.step-form-horizontal ol li.disabled span {
  color: #EB8153;
}

@media (max-width: 767.98px) {
  .step-form-horizontal ol li {
    padding-left: 0;
    padding-right: 0;
    margin: 0;
  }
}

@media (max-width: 575.98px) {
  .step-form-horizontal ol li {
    font-size: 0.75rem;
    padding-top: 0.9375rem;
  }
}

.step-form-horizontal ol li span {
  position: relative;
  background-color: #fff;
  border: 3px solid #d7dae3;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 3rem;
  border-radius: 50px;
  width: 3rem;
  padding: 0 !important;
  box-shadow: 0 0 0 3px #fff;
  z-index: 2;
  position: relative;
}

[data-theme-version="dark"] .step-form-horizontal ol li span {
  background: #181f39;
  border-color: #333a54;
}

.step-form-horizontal ol li:last-child {
  width: auto;
}

.step-form-horizontal ol::after {
  position: absolute;
  width: 100%;
  height: 4px;
  content: "";
  left: 0;
  top: 23px;
  background-color: #eee;
  z-index: 1;
}

.step-form-horizontal .actions {
  padding: 0;
}

@media only screen and (max-width: 575px) {
  .step-form-horizontal .actions {
    padding: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/jsx/step.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;;;;;;;EAOE,qBAAqB;AACvB;;AAEA;;EAEE,6BAA6B;EAC7B,kBAAkB;EAClB,WAAW;AACb;;AAEA;;;;EAIE,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE;IACE,eAAe;IACf,gBAAgB;IAChB,SAAS;EACX;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,sBAAsB;EACxB;AACF;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EAET,2BAA2B;EAC3B,sBAAsB;EACtB,yBAAyB;EAGzB,aAAa;EAGb,uBAAuB;EAGvB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,WAAW;EACX,SAAS;EACT,YAAY;EACZ,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE;IACE,gBAAgB;IAChB,eAAe;EACjB;AACF;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;;;EAKE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;;;;EAME,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE,kBAAkB;EAGlB,wBAAwB;EACxB,eAAe;EAGf,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,gBAAgB;EAChB,kCAAkC;EAClC,UAAU;EACV,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,WAAW;EACX,QAAQ;EACR,OAAO;EACP,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EAEnB,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;;EAGE,6BAA6B;EAC7B,kBAAkB;EAClB,WAAW;EACX,SAAS;AACX;;AAEA;;;;;;EAME,6BAA6B;EAC7B,WAAW;AACb;;AAEA;;EAEE,cAAc;EACd,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,eAAe;IACf,gBAAgB;IAChB,SAAS;EACX;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,sBAAsB;EACxB;AACF;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EAGzB,aAAa;EAGb,uBAAuB;EAGvB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EAErB,0BAA0B;EAC1B,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,WAAW;EACX,OAAO;EACP,SAAS;EACT,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE;IACE,UAAU;EACZ;AACF","sourcesContent":["form#step-form-horizontal > div:last-child {\n  /* text-align: right; */\n  /* padding-top: 2rem; */\n}\n\nform#step-form-horizontal .form-group .text-label {\n  text-align: left;\n  display: block;\n  /* padding-top: 2rem; */\n}\n[data-primary=\"color_2\"] .wizard > .steps li.current a {\n  background-color: #EB8153;\n}\n[data-primary=\"color_2\"] .wizard .skip-email a {\n  color: #363062;\n}\n[data-primary=\"color_2\"] .wizard > .actions li:not(.disabled) a {\n  background-color: #EB8153;\n}\n\n.step-form-horizontal .wizard {\n  padding-top: 3.5rem;\n}\n\n.step-form-horizontal .wizard .steps li {\n  position: relative;\n}\n\n.step-form-horizontal .wizard .steps li.done a {\n  text-align: center;\n  background-color: #fff;\n  color: #6e6e6e;\n}\n\n[data-theme-version=\"dark\"] .step-form-horizontal .wizard .steps li.done a {\n  background-color: #181f39;\n  color: #7e7e7e;\n}\n\n.step-form-horizontal .wizard .steps li.done a:hover {\n  text-align: center;\n  background-color: #fff;\n  color: #6e6e6e;\n}\n\n.step-form-horizontal .wizard .steps li.done a .number {\n  color: #fff;\n  background: #EB8153;\n  border-color: transparent;\n}\n\n[data-theme-version=\"dark\"]\n  .step-form-horizontal\n  .wizard\n  .steps\n  li.done\n  a\n  .number {\n  border-color: #EB8153;\n}\n\n.step-form-horizontal .wizard .steps li.current a,\n.step-form-horizontal .wizard .steps li.disabled a {\n  background-color: transparent;\n  text-align: center;\n  color: #fff;\n}\n\n.step-form-horizontal .wizard .steps li.current a:hover,\n.step-form-horizontal .wizard .steps li.current a:active,\n.step-form-horizontal .wizard .steps li.disabled a:hover,\n.step-form-horizontal .wizard .steps li.disabled a:active {\n  background-color: transparent;\n  color: #fff;\n}\n\n.step-form-horizontal .wizard .steps li.current a .number {\n  color: #363062;\n  background: #fff;\n  border: 2px solid #EB8153;\n}\n\n.step-form-horizontal .wizard .steps li.disabled a .number {\n  color: #EB8153;\n}\n\n.step-form-horizontal .wizard .steps li a {\n  position: relative;\n  z-index: 1;\n}\n\n@media (max-width: 767.98px) {\n  .step-form-horizontal .wizard .steps li a {\n    padding-left: 0;\n    padding-right: 0;\n    margin: 0;\n  }\n}\n\n@media (max-width: 575.98px) {\n  .step-form-horizontal .wizard .steps li a {\n    font-size: 0.75rem;\n    padding-top: 0.9375rem;\n  }\n}\n\n.step-form-horizontal .wizard .steps li a .number {\n  position: absolute;\n  top: -55px;\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n  transform: translateX(-50%);\n  background-color: #fff;\n  border: 3px solid #d7dae3;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  height: 3rem;\n  border-radius: 50px;\n  width: 3rem;\n}\n\n[data-theme-version=\"dark\"] .step-form-horizontal .wizard .steps li a .number {\n  background: #181f39;\n  border-color: #333a54;\n}\n\n@media only screen and (max-width: 575px) {\n  .step-form-horizontal .wizard .steps li a .number {\n    top: -45px;\n  }\n}\n\n.step-form-horizontal .wizard .steps li:not(:last-child) {\n  z-index: 1;\n}\n\n.step-form-horizontal .wizard .steps li:not(:last-child)::after {\n  position: absolute;\n  width: 100%;\n  height: 0.375rem;\n  content: \"\";\n  left: 50%;\n  top: -2.1rem;\n  background-color: #EB8153;\n  z-index: -1;\n}\n\n@media (max-width: 575.98px) {\n  .step-form-horizontal .wizard .steps li:not(:last-child)::after {\n    height: 0.375rem;\n    top: -1.3125rem;\n  }\n}\n\n.step-form-horizontal .wizard .steps li:not(:last-child).current::after {\n  background-color: #f3f3f3;\n}\n\n[data-theme-version=\"dark\"]\n  .step-form-horizontal\n  .wizard\n  .steps\n  li:not(:last-child).current::after {\n  background: #181f39;\n}\n\n.step-form-horizontal .wizard .steps li:not(:last-child).current ~ li::after {\n  background-color: #f3f3f3;\n}\n\n[data-theme-version=\"dark\"]\n  .step-form-horizontal\n  .wizard\n  .steps\n  li:not(:last-child).current\n  ~ li::after {\n  background: #181f39;\n}\n\n.step-form-horizontal .wizard .actions {\n  padding: 0;\n}\n\n@media only screen and (max-width: 575px) {\n  .step-form-horizontal .wizard .actions {\n    padding: 0;\n  }\n}\n\n.step-form-horizontal ol {\n  position: relative;\n  display: -webkit-box !important;\n  display: -ms-flexbox !important;\n  display: flex !important;\n  padding-left: 0;\n  -webkit-box-pack: justify;\n  -ms-flex-pack: justify;\n  justify-content: space-between;\n}\n\n.step-form-horizontal ol li {\n  position: relative;\n  border: 0;\n  margin-bottom: 0;\n  background: transparent !important;\n  z-index: 2;\n  padding: 0 !important;\n  width: 33.33%;\n}\n\n.step-form-horizontal ol li:after {\n  content: none !important;\n}\n\n.step-form-horizontal ol li:before {\n  content: \"\";\n  height: 3px;\n  width: 0;\n  left: 0;\n  top: 23px;\n  position: absolute;\n  background: #e23428;\n  -webkit-transition: all 0.5s;\n  transition: all 0.5s;\n  z-index: 1;\n}\n\n.step-form-horizontal ol li.go767851704 {\n  text-align: center;\n  background-color: #fff;\n  color: #6e6e6e;\n}\n\n.step-form-horizontal ol li.go767851704:before {\n  width: 100%;\n}\n\n[data-theme-version=\"dark\"] .step-form-horizontal ol li.go767851704 {\n  background-color: #181f39;\n  color: #7e7e7e;\n}\n\n.step-form-horizontal ol li.go767851704:hover {\n  text-align: center;\n  background-color: #fff;\n  color: #6e6e6e;\n}\n\n.step-form-horizontal ol li.go767851704 span {\n  color: #fff;\n  background: #e23428;\n  border-color: transparent;\n}\n\n[data-theme-version=\"dark\"] .step-form-horizontal ol li.go767851704 span {\n  border-color: #EB8153;\n}\n\n.step-form-horizontal ol li.active,\n.step-form-horizontal ol li.go2478912419,\n.step-form-horizontal ol li.disabled {\n  background-color: transparent;\n  text-align: center;\n  color: #fff;\n  border: 0;\n}\n\n.step-form-horizontal ol li.active:hover,\n.step-form-horizontal ol li.active:active,\n.step-form-horizontal ol li.go2478912419:hover,\n.step-form-horizontal ol li.go2478912419:active,\n.step-form-horizontal ol li.disabled:hover,\n.step-form-horizontal ol li.disabled:active {\n  background-color: transparent;\n  color: #fff;\n}\n\n.step-form-horizontal ol li.active span,\n.step-form-horizontal ol li.go2478912419 span {\n  color: #e23428;\n  background: #fff;\n  border: 2px solid #e23428;\n}\n\n.step-form-horizontal ol li.disabled span {\n  color: #EB8153;\n}\n\n@media (max-width: 767.98px) {\n  .step-form-horizontal ol li {\n    padding-left: 0;\n    padding-right: 0;\n    margin: 0;\n  }\n}\n\n@media (max-width: 575.98px) {\n  .step-form-horizontal ol li {\n    font-size: 0.75rem;\n    padding-top: 0.9375rem;\n  }\n}\n\n.step-form-horizontal ol li span {\n  position: relative;\n  background-color: #fff;\n  border: 3px solid #d7dae3;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  height: 3rem;\n  border-radius: 50px;\n  width: 3rem;\n  padding: 0 !important;\n  -webkit-box-shadow: 0 0 0 3px #fff;\n  box-shadow: 0 0 0 3px #fff;\n  z-index: 2;\n  position: relative;\n}\n\n[data-theme-version=\"dark\"] .step-form-horizontal ol li span {\n  background: #181f39;\n  border-color: #333a54;\n}\n\n.step-form-horizontal ol li:last-child {\n  width: auto;\n}\n\n.step-form-horizontal ol::after {\n  position: absolute;\n  width: 100%;\n  height: 4px;\n  content: \"\";\n  left: 0;\n  top: 23px;\n  background-color: #eee;\n  z-index: 1;\n}\n\n.step-form-horizontal .actions {\n  padding: 0;\n}\n\n@media only screen and (max-width: 575px) {\n  .step-form-horizontal .actions {\n    padding: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
